export default "__VITE_ASSET__f7b5c85d__"